/**
 * Created by OLD on 20/11/2015.
 */
define('removeBackgroundMain',[
  'module',
  'logger',
  'removeBackgroundRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var RemoveBackground = {
    start: function() {
      Logger.log(module, 'starting removeBackgroundModule');
    },

    stop: function() {
      Logger.log(module, 'stopping removeBackgroundModule');
    }
  };

  module.exports = RemoveBackground;
});
